import { appDoneBlack24DpIcon } from './done_black_24dp';
import { appInfoBlack24DpIcon } from './info_black_24dp';
import { appTocBlack24DpIcon } from './toc_black_24dp';
import { appUploadFileBlack24DpIcon } from './upload_file_black_24dp';
export const tenantsActivationIcons = [appDoneBlack24DpIcon, appInfoBlack24DpIcon, appTocBlack24DpIcon, appUploadFileBlack24DpIcon];
